import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { actions } from '../../modules/Actions';
import { SearchConditionState } from '../SearchConditionReducer';

export interface filterConditionState extends filterKeyState {
  searchConditions: SearchConditionState;
}

export interface filterKeyState {
  filterKey: string;
  filterTitle: string;
}

export const initialCurrentFilterState: filterKeyState = {
  filterKey: '',
  filterTitle: '',
};

export const currentFilterReducer = reducerWithInitialState(initialCurrentFilterState)
  .case(actions.updateCurrentFilter, (state: filterKeyState, payload: filterKeyState) => {
    return {
      ...payload,
    };
  })
  .case(actions.clearFilter, (state: filterKeyState) => {
    return initialCurrentFilterState;
  });
